import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IAgentChatRoomListClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentChatRoomListClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class AgentChatRoomListClient implements IAgentChatRoomListClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, companyName } = input;

        const params = new URLSearchParams();
        const queryString = params.toString();
        if (companyName) {
            params.append('company_name', companyName);
        }
        const PATH = `${API_LOCATION_URL}/agent/chat_rooms?${queryString}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
